import { db } from '../client/index';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc, query, where } from 'firebase/firestore/lite';

const productsCollection = collection(db, 'products');

export const getProducts = async () => {
  try {
    const productsSnapshot = (await getDocs(productsCollection)).docs;
    const productsItems = productsSnapshot.map(product => ({ id: product.ref.id, ...product.data() }));
    return productsItems;
  } catch (err) {
    return err;
  }
}

export const getProductsByCategory = async (categoryId) => {
  try {
    const querySnapshot = query(productsCollection, where('category', '==', categoryId));
    const queryItems = (await getDocs(querySnapshot)).docs;
    const productsItems = queryItems.map(product => ({ id: product.ref.id, ...product.data() }));
    return productsItems;
  } catch (err) {
    return err;
  }
}

export const getProduct = async (id) => {
  try {
    const productSnapshot = doc(db, 'products', id);
    const productItem = await getDoc(productSnapshot);
    return productItem.exists() ? productItem.data() : null;
  } catch (err) {
    return err;
  }
}

export const createProduct = async (product) => {
  try {
    const { id } = await addDoc(productsCollection, product);
    const productAdded = { id, ...product };
    return productAdded;
  } catch (err) {
    return err;
  }
}

export const updateProduct = async (id, product) => {
  try {
    const productRef = doc(db, 'products', id);
    await updateDoc(productRef, product);
    return { id, ...product };
  } catch (err) {
    return err;
  }
}

export const deleteProduct = async (id) => {
  try {
    const productRef = doc(db, 'products', id);
    await deleteDoc(productRef);
    return id;
  } catch (err) {
    return err;
  }
}